import { apiRequest } from '../../../services/api/client';
import { Segment } from '../types/trimestersSettings.types';

const SEGMENTS_CHANGED_EVENT = 'trimesters:segments-changed';

type SegmentResource = {
  id: number;
  name: string;
  minimum_age: number | null;
  maximum_age: number | null;
  active: boolean;
  magazines_count?: number;
};

type SegmentListResponse = {
  data: SegmentResource[];
  meta: {
    current_page: number;
    last_page: number;
    total: number;
    has_more_pages: boolean;
  };
};

type SegmentResponse = {
  data: SegmentResource;
};

export interface SaveSegmentInput {
  name: string;
  ageStart: number;
  ageEnd: number;
  active?: boolean;
}

const emitSegmentsChanged = () => {
  window.dispatchEvent(new CustomEvent(SEGMENTS_CHANGED_EVENT));
};

const toSegment = (segment: SegmentResource): Segment => ({
  id: String(segment.id),
  name: segment.name,
  ageStart: segment.minimum_age ?? 0,
  ageEnd: segment.maximum_age ?? 0,
  active: segment.active,
  magazinesCount: segment.magazines_count ?? 0,
});

const toPayload = (input: SaveSegmentInput) => ({
  name: input.name,
  minimum_age: input.ageStart,
  maximum_age: input.ageEnd,
  active: input.active ?? true,
});

export const segmentsService = {
  changedEvent: SEGMENTS_CHANGED_EVENT,

  async list() {
    const firstPage = await apiRequest<SegmentListResponse>('/ebd/segments?per_page=100');
    return firstPage.data.map(toSegment);
  },

  async create(input: SaveSegmentInput) {
    const payload = await apiRequest<SegmentResponse>('/ebd/segments', {
      method: 'POST',
      body: JSON.stringify(toPayload(input)),
    });

    emitSegmentsChanged();
    return toSegment(payload.data);
  },

  async update(id: string, input: SaveSegmentInput) {
    const payload = await apiRequest<SegmentResponse>(`/ebd/segments/${id}`, {
      method: 'PUT',
      body: JSON.stringify(toPayload(input)),
    });

    emitSegmentsChanged();
    return toSegment(payload.data);
  },

  async remove(segmentId: string) {
    await apiRequest<void>(`/ebd/segments/${segmentId}`, {
      method: 'DELETE',
    });

    emitSegmentsChanged();
  },
};
